<template>
  <footer class="footer" data-gtm-context="Footer">
    <div class="divider--dashed"></div>
    <div class="container-fluid">
      <div class="row between-sm pb-16">
        <div class="col-xs-12">
          <div class="footer__links">
            <div class="footer__links-column">
              <h6 class="footer__links-column-header">Transpond</h6>
              <ul class="footer__links-list">
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/features/"
                    >Features</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/pricing/"
                    >Pricing</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/emailtemplates/"
                    >Email Templates</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <a
                    class="footer__links-link"
                    href="https://agency.transpond.io/"
                    >White Label for Agencies &amp; Resellers</a
                  >
                </li>
              </ul>
            </div>
            <div class="footer__links-column">
              <h6 class="footer__links-column-header">Company</h6>
              <ul class="footer__links-list">
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/about/"
                    >About</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/media/"
                    >Brand Resources</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/contactus/"
                    >Contact Us</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link
                    class="footer__links-link"
                    to="/gdprcontactlocations/"
                    >GDPR</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="footer__links-column">
              <h6 class="footer__links-column-header">Integrations</h6>
              <ul class="footer__links-list">
                <li class="footer__links-list-item">
                  <router-link
                    class="footer__links-link"
                    to="/integrations/capsule-email-marketing/8/"
                    >Capsule</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link
                    class="footer__links-link"
                    to="/integrations/slack-email-marketing/53/"
                    >Slack</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link
                    class="footer__links-link"
                    to="/integrations/zapier-email-marketing/41/"
                    >Zapier</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/integrations/"
                    >All Integrations</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="footer__links-column">
              <h6 class="footer__links-column-header">Resources</h6>
              <ul class="footer__links-list">
                <li class="footer__links-list-item">
                  <a class="footer__links-link" href="/support"
                    >Support</a
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/blog/"
                    >Blog</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/infographics/"
                    >Infographics</router-link
                  >
                </li>
                <li class="footer__links-list-item">
                  <router-link class="footer__links-link" to="/videos/"
                    >Videos</router-link
                  >
                </li>

                <li class="footer__links-list-item">
                  <a
                    class="footer__links-link"
                    v-on:click="trackDeveloperApi"
                    target="_blank"
                    >Developer API</a
                  >
                </li>

                <li class="footer__links-list-item">
                  <router-link
                    class="footer__links-link"
                    to="/partner-program/"
                    >Partner Program</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="footer__links-column footer__links-column--brand">
              <div class="footer__social">
                <a
                  class="footer__social-link"
                  href="https://twitter.com/Transpondio"
                >
                  <TwitterIcon class="footer__social-icon"></TwitterIcon>
                </a>
                <a
                  class="footer__social-link"
                  href="https://www.facebook.com/transpond.io"
                >
                  <FacebookIcon class="footer__social-icon"></FacebookIcon>
                </a>
                <a
                  class="footer__social-link"
                  href="https://www.instagram.com/transpond.io/"
                >
                  <InstagramIcon class="footer__social-icon"></InstagramIcon>
                </a>
              </div>
              <div class="footer__legal-wrapper">
                <div class="footer__legal">
                  © {{ year }} Transpond. All Rights Reserved.
                </div>
                <div class="footer__legal-links">
                  <router-link class="footer__legal-link" to="/terms/"
                    >Terms</router-link
                  >
                  <router-link class="footer__legal-link" to="/privacy/"
                    >Privacy</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- <CookieMessage></CookieMessage> -->
</template>

<script>
import TwitterIcon from "./Svgs/TwitterIcon";
import FacebookIcon from "./Svgs/FacebookIcon";
import InstagramIcon from "./Svgs/InstagramIcon";
// import CookieMessage from "@/components/CookieMessage";
import TrackingHelpers from "@/functions/tracking";
import { gtmTracking } from "@/functions/gtm-tracking";


export default {
  components: {
    TwitterIcon,
    FacebookIcon,
    InstagramIcon,
    // CookieMessage,
  },
  setup()
  {
    return { TrackingHelpers }
  },
  data() {
    let year = new Date().getFullYear();

    return {
      year: year
    };
  },
  ///component has mounted
  created() {
    //see if they have a cookie

  },

  //functions
  methods: {
    trackDeveloperApi() {
      gtmTracking("Footer Click", "Developer API", "")();
      TrackingHelpers.linkToApp("apidocs/1");
    },
  },
};
</script>
